import * as types from "./actionTypes";

// Action dispatchers

export const onboardLoadedState = (onboardState) => ({
  type: types.ONBOARD_LOADED_STATE,
  payload: onboardState,
});

export const onboardUpdateState = (progress) => ({
  type: types.ONBOARD_UPDATE_STATE,
  progress,
});

export const setLoadingState = (loading) => ({
  type: types.SET_LOADING_STATE,
  payload: loading,
});

export const setModalState = (isOpenModal) => ({
  type: types.SET_MODAL_STATE,
  payload: isOpenModal,
});

export const markDocumentRead = (documentFilename) => ({
  type: types.MARK_DOCUMENT_READ,
  payload: documentFilename,
});

export const postReflexAllenOnboardingForm = (formData) => ({
  type: types.POST_REFLEX_ALLEN_FORM,
  payload: formData,
});

export const requestReflexAllenPdf = (formCode) => ({
  type: types.REQUEST_REFLEX_ALLEN_FORMS,
  payload: formCode,
});

export const setDownloadingReflexAllenPdf = (formCode, isDownloading) => ({
  type: types.SET_DOWNLOADING_REFLEX_ALLEN_FORMS,
  payload: { formCode, isDownloading },
});

export const setReflexAllenPdf = (payload) => ({
  type: types.SET_REFLEX_ALLEN_FORMS,
  payload,
});

export const postReflexAllenInductionProgramme = (content) => ({
  type: types.POST_REFLEX_ALLEN_INDUCTION_PROGRAMME,
  payload: content,
});

export const refreshSections = () => ({
  type: types.REFRESH_SECTIONS,
});
